import gql from "graphql-tag";

export const REMOVE_REMINDER = gql`
  mutation removeReminder($id: ID!) {
    removeReminder(id: $id) {
      _id
    }
  }
`;
